export const environment = {
  production: true,
  serverUrl: 'https://api-staging-iris.phx-smartschool.com'
};
